<template>
  <div class="body me-3 position-relative " style="width:200px ">
    <div class=" mt-2">
      <el-progress :percentage="process"></el-progress>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoadingBarFile",
  props: {
    timePercent: {
      type: Number
    }
  },
  data() {
    return {
      process: 0
    };
  },
  methods: {
    loading(timeDelay = 0) {
      let items = [90, 92, 95, 99, 97, 98];
      var item = items[Math.floor(Math.random() * items.length)];
      var i = 0;
      let ref = this;
      (async function draw() {
        if (i <= item) {
          await new Promise((resolve) => setTimeout(resolve, timeDelay));
          requestAnimationFrame(draw);
          ref.process = i;
          i = i + 1;
        }
      })();
    }
  },

  mounted() {
    this.loading(this.timePercent);
  }
};

</script>

<style scoped>

</style>